// const BASE_URL = 'http://localhost:8080'; 

const BASE_URL = 'https://mobiusunityconsulting.com'; 


export { BASE_URL};